import { AuthService } from './common/service/auth.service';
import { ApiService } from 'src/app/common/service/api.service';
import { Component, OnInit } from '@angular/core';

import { Platform, ToastController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { environment } from 'src/environments/environment';
import { GlobalService } from './common/service/global.service';
import { SwUpdate } from '@angular/service-worker';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private api: ApiService,
    private authService: AuthService,
    private globalService: GlobalService,
    private swUpdate: SwUpdate,
    private toastCtrl: ToastController
  ) {
    this.splashScreen.show();
    this.checkForUpdates();
   
  }
  async ngOnInit(): Promise<void> {
    await this.initializeApp();
    this.globalService.loadAccounts();
  }

  async initializeApp() {
    const res = await this.api.get(environment.userAdmin + '/' + this.authService.getToken());
    environment.isAdmin = res.result;
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }
  async checkForUpdates() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe(async (event) => {
        console.log(event);
        if (event.type === 'VERSION_READY') {
          const toast = await this.toastCtrl.create({
            message: 'New version available!',
            position: 'bottom',
            duration: 10000,
            buttons: [
              {
                text: 'Update',
                role: 'reload',
                handler: () => {
                  this.swUpdate.activateUpdate().then(() => document.location.reload());
                },
              },
            ],
          });

          await toast.present();
        }
      });
    }
  }
}
